import { render, staticRenderFns } from "./block-single-notification.vue?vue&type=template&id=72f23bfa&scoped=true&lang=pug&"
import script from "./block-single-notification.vue?vue&type=script&lang=js&"
export * from "./block-single-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f23bfa",
  null
  
)

export default component.exports